import { jsx as _jsx } from "react/jsx-runtime";
import HomePage from "../../components/HomePage/index";
var Home = function () { return _jsx(HomePage, {}); };
export default Home;
